<div style="padding: 0 7px 0 0; float: right;">
  <div *ngIf="customReport2ReportReportElementId == null" style="padding: 7px 7px 7px 7px; background-color: #dae4ee;">
    <dx-button icon="menu"   (onClick)="popupVisible = !popupVisible"></dx-button>
  </div>
</div>

  <div *ngIf="selectedReportId !== null">
    <div *ngIf="customReport1ReportReportElementId > 0">
      <app-custom-report1
        [showPublicly]="true"
        [showTitle]="true"
        (refreshCallbackChanged)="refreshCallbackChanged($event)"
        [reportReportElementId]="customReport1ReportReportElementId">
      </app-custom-report1>
    </div>
    <div *ngIf="customReport2ReportId > 0">
      <app-custom-report2
        [showPublicly]="true"
        [showTitle]="true"
        [reportId]="customReport2ReportId"
        (refreshCallbackChanged)="refreshCallbackChanged($event)"
        (selectedReportReportElementIdChanged)="customReport2ReportReportElementIdChanged($event)">
      </app-custom-report2>
    </div>
    <div *ngIf="productionStatusReportId > 0">
      <app-production-status-report
        (refreshCallbackChanged)="refreshCallbackChanged($event)"
        [showPublicly]="true"
        [showTitle]="true"
        [reportId]="productionStatusReportId">
      </app-production-status-report>
    </div>
    <div *ngIf="customReport2ReportReportElementId > 0">
      <div style="float: right; padding: 5px 5px 5px 5px;">
        <dx-button icon="close" type="danger" (onClick)="closeCustomReport2Details()"></dx-button>
      </div>
      <app-custom-report2-element-details
        [showTitle]="true"
        [showPublicly]="true"
        (refreshCallbackChanged)="refreshCallbackChanged($event)"
        [reportReportElementId]="customReport2ReportReportElementId">
      </app-custom-report2-element-details>
    </div>
  </div>

  <dx-popup [width]="900"
            [height]="650"
            [showTitle]="true"
            title="{{ls.LNG('Label.SelectAReport')}}"
            [dragEnabled]="false"
            [hideOnOutsideClick]="true"
            [(visible)]="popupVisible"
            (onShowing)="popupOnShowing($event)"
            (onHiding)="popupOnHiding($event)">
    <div *dxTemplate="let data of 'content'">
      <div style="margin-bottom: 5px;">
        <dx-select-box [dataSource]="languages" [(value)]="selectedLanguageId"  valueExpr="LanguageId" [displayExpr]="languageDispExpr" width="200" (onItemClick)="languageItemClick($event)" itemTemplate="it">
          <div *dxTemplate="let t of 'it'">
            <div style="white-space: nowrap;">{{languageDispExpr(t)}}</div>
          </div>
        </dx-select-box>
      </div>
      <dx-data-grid [dataSource]="reports"
                    (onRowClick)="gridOnRowClick($event)"
                    keyExpr="ReportId"
                    heigth="580"
                    [hoverStateEnabled]="true"
                    (onContentReady)="gridOnContentReady($event)">
        <dxo-selection mode="single"></dxo-selection>
        <dxo-paging [enabled]="false"></dxo-paging>
        <dxi-column dataField="CustomElementNumber" groupIndex="0" groupCellTemplate="gct"></dxi-column>
        <dxi-column width="'30%'" dataField="Name"></dxi-column>
        <dxi-column dataField="Description"></dxi-column>
        <div *dxTemplate="let t of 'gct'">
          {{getGroupByText(t.data)}}
        </div>
      </dx-data-grid>
    </div>
  </dx-popup>
